<template>
	<nav class="AppTopbar" >
		<div class="logo">
			<a href="/u" class="mark" ><img src="/img/mark.svg" alt=""></a>
            <div :class="{TopSwitcher:1,open:switcher_open}" v-if="brand">
                <div class="arrow">&rsaquo;</div>
                <div class="active">
                    <button :class="{clickable:can_switch}" @click="openSwitcher">{{ brand.name }}</button>
                    <div class="switcher" v-if="switcher_open" >
                        <a v-for="account in user.accounts.filter(x=>x.id!=provider.id)" :key="account.id" :href="'/p/'+account.id" >{{ account.name }}</a>
                    </div>
                </div>

            </div>
		</div>

		<div class="user" v-if="is_logged_in">
			<button @click="menu_open=!menu_open" class="user_button" >Hi <b>{{user.first_name}}</b></button>
			<div class="menu" v-if="menu_open">
				<!-- <a href="/u">Switch accounts</a> -->
				<a href="/u/settings">Account settings</a>
				<button @click="logoutClick()" >Logout</button>
			</div>
		</div>
	</nav>
	<div class="AppTopbar_under_menu" v-if="menu_open || switcher_open" @click="switcher_open=menu_open=false" ></div>
</template>

<style lang="scss" scoped>
.TopSwitcher{
    display:inline-flex;
    align-items: center;
    margin-left:10px;

    .active{
        position: relative;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
    
        button{
            padding:10px 20px;
            border:none;
            background:none;
            cursor: default;

            &.clickable{
                &:hover{
                    cursor: pointer;
                    background:#191919;
                }
            }
        }

        .switcher{
            position: absolute;
            top:100%;
            left:0;
            background:#111;
            font-size:1rem;
            min-width: 100%;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;

            a{
                display:block;
                padding:10px 20px;
                color:#AAA;
                text-decoration: none;

                &:hover{
                    background:#000;
                    color:#FFF;
                }
            }
        }
    }

    &.open{
        .active{
            background:#111;
        }
    }
}
</style>

<script>

	import {ref} from "vue";

	export default {
		props : [
			'is_logged_in',
			'user',
			'logout',
			'provider', // optional
		],				
		
		setup() {					
			return {
				menu_open : ref(false),
				switcher_open : ref(false),
            };
		},

		computed:{
			brand(){

				if(this.provider){
					return {
						name : this.provider.name,
					}
				}

				return false;
			},
            can_switch(){
                return ((this.user||{}).accounts||[]).filter(x=>x.id!=this.provider.id).length > 0; 
            }
		},
		
		methods:{
			logoutClick(){
				this.logout().then(()=>{
					this.$router.push({name:'Login'});
				});
			},
            openSwitcher(){
                if(this.can_switch){
                    this.switcher_open=!this.switcher_open;
                }
            }
		}

	}
</script>